class ProductTemplate extends HTMLElement {
  constructor() {
    super();
    this.initEventListener();
    this.setDateText();
    this.updateAllInputsOnClik();
    this.showAddToCard();
    window.addEventListener("scroll", this.showAddToCard.bind(this));

  }


  initEventListener() {
    this.querySelectorAll(".faq-item-title").forEach((button) => {
      button.addEventListener('click', this.toggleFaqItem.bind(this));
    });
    this.swiper = new Swiper(this.querySelector('.swiper-product'), {

      direction: 'horizontal',
      loop: false,
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });
    this.querySelector('.product-template__button').addEventListener('click', (event) => {
      event.preventDefault();
    });

    // INSTAGRAM FORM FUNCTION //
    this.InstagramInput = document.getElementById('contact_ig')
    this.PhoneInput = document.getElementById('contact_phone')
    this.FreeBudButton = document.getElementById('submit-button')
    this.InstagramSuccess = document.getElementById('instagram-success')



    // this.FreeBudButton.addEventListener("click", this.handleInstaPostForm.bind(this));
  };

  toggleFaqItem(e) {
    e.currentTarget.classList.toggle("faq-display-none")
    const item = e.currentTarget.parentNode.querySelector(".faq-item-text");
    item.slideToggle("250");

  }

  handleInstaPostForm() {
    const from = this.InstagramInput.value
    const phone = this.PhoneInput.value
    if (!!from && !!phone) {
      $.ajax({
        type: 'POST',
        url: 'https://tealerlab-api.usedrop.io/api/gift',
        dataType: 'json',
        data: {
          from,
          phone
        },
        success: function () {
          this.InstagramSuccess.classList.add("show");
          this.FreeBudButton.classList.add("hidden")
        }
      });
    }
  }

  setDateText() {

    if (document.querySelector('.product-template__scrolling-date-container')) {
      var currentDate = new Date();
      var firstDate = new Date(currentDate);
      var secondDate = new Date(currentDate);
      console.log(secondDate);


      for (var i = 0; i < Number(document.querySelector('.product-template__scrolling-date-container').getAttribute('data-date-1')); i++) {
        firstDate.setDate(firstDate.getDate() + 1);
        if (firstDate.getDay() == 6) {
          firstDate.setDate(firstDate.getDate() + 2);
        }
        if (firstDate.getDay() == 0) {
          firstDate.setDate(firstDate.getDate() + 1);
        }
      }

      for (var i = 0; i < Number(document.querySelector('.product-template__scrolling-date-container').getAttribute('data-date-2')); i++) {
        secondDate.setDate(secondDate.getDate() + 1);
        if (secondDate.getDay() == 6) {
          secondDate.setDate(secondDate.getDate() + 2);
        }
        if (secondDate.getDay() == 0) {
          secondDate.setDate(secondDate.getDate() + 1);
        }
      }

      console.log(secondDate);
      var formatOptions = { month: 'numeric', day: 'numeric' };
      var firstDeliveryDateString = firstDate.toLocaleDateString('fr-FR', formatOptions);
      var secondDeliveryDateString = secondDate.toLocaleDateString('fr-FR', formatOptions);

      var deliveryText = document.querySelector('.product-template__scrolling-date').textContent;
      deliveryText = deliveryText.replace("[1]", firstDeliveryDateString);
      deliveryText = deliveryText.replace("[2]", secondDeliveryDateString);
      document.querySelectorAll('.product-template__scrolling-date').forEach((elem) => {
        elem.textContent = deliveryText;
      })
    }

  }

  showAddToCard() {

    let add_to_cart_btn = this.querySelector(".main-product-form");
    let sticky_add_to_cart_btn = this.querySelector(".product-template__bottom-bar");

    if (this.isInViewport(add_to_cart_btn) || window.scrollY < 700) {
      sticky_add_to_cart_btn.classList.remove("active");
    } else {
      sticky_add_to_cart_btn.classList.add("active");
    }
  }

  isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  updateAllInputsOnClik() {
    this.querySelectorAll('variant-radios input').forEach((input) => {
      input.addEventListener('change', (e) => {
        let name = e.currentTarget.getAttribute('name');
        let value = e.currentTarget.value;

        console.log(`.select__select[name="options[${name}}]"`);

        let select = document.querySelector(`.select__select[name="options[${name}]"`);
        select.value = value;
        select.closest('variant-selects').dispatchEvent(new Event('change'));
      });
    });
  }
}
customElements.define("product-template", ProductTemplate);

const items = document.querySelectorAll('.accordion button');

function toggleAccordion() {
    const itemToggle = this.getAttribute('aria-expanded');

    for (i = 0; i < items.length; i++) {
        items[i].setAttribute('aria-expanded', 'false');
    }

    if (itemToggle == 'false') {
        this.setAttribute('aria-expanded', 'true');
    }
}

items.forEach((item) => item.addEventListener('click', toggleAccordion));

